let homeData = [];

homeData = [
        {
            title: "Fun Websites",
            description: "We have a collection of fun websites and games, all of which were created by computer programmers, just like you!",
            link: "#/games"
        },
        {
            title: "Art",
            description: "Fun generative art created with computer science!",
            link: "#/art"
        },
        {
            title: "AI Bias",
            description: "Learn some more about AI (Artificial Intelligence) Bias (what happens when AI consistently favors or discriminates against certain groups).",
            link: "#/AIBias"
        },
        {
            title: "Binary Information",
            description: "Learn some more about how binary works and computers store information",
            link: "#/binaryInformation"
        },
        {
            title: "Computer Science Careers",
            description: "Learn more about computer science careers and what you can do with your new Computer Science knowledge!",
            link: "#/CSCareers"
        },
        {
            title: "How to Make a Zine",
            description: "Learn how to fold the 8-page zines included in your kit, or make your own!",
            link: "#/zines"
        }
    ]


export default homeData;